import { combineReducers } from "redux";
import dashboardReducer from "./dashboardReducer";
import reportReducer from "./reportReducer";

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  report: reportReducer,
  // Agrega otros reducers aquí
});

export default rootReducer;
